<template>
  <tr>
    <td>
      <p class="mb-0">
        <a target="_blank" :href="websiteUrl + product.url"><strong>{{ product.name }}</strong></a>
        <span class="small text-muted">({{ product.store_based_product_id }}) - {{ product.stock_status.name }}</span>
      </p>
      <p v-if="product.model" class="mb-0" style="margin-top:1px">
        <span class="text-muted">Model:</span> {{ product.model }}
      </p>
      <p v-if="product.sku" class="mb-0" style="margin-top:1px">
        <span class="text-muted">SKU:</span> {{ product.sku }}
      </p>
      <template v-if="product.options && product.options.length">
        <p v-for="(option,k) in product.options" :key="k" class="mb-0" style="margin-top:1px">
          <span class="text-muted">{{ option.group }}:</span> {{ option.value }}
        </p>
      </template>
      <template v-if="product.attributes && product.attributes.length">
        <p v-for="(attribute,k) in product.attributes" :key="k" class="mb-0" style="margin-top:1px">
          <span class="text-muted">{{ attribute.name }}:</span> {{ attribute.value }}
        </p>
      </template>
      <p v-if="product.shipping_method" class="mb-0" style="margin-top:1px">
        <span class="text-muted">Shipping Method:</span>
        {{ product.shipping_method.name }}
      </p>
      <p v-if="product.product_units && product.product_units.length" class="mb-0" style="margin-top:1px">
        <span class="text-muted">Product Units:</span> <span v-for="(product_unit, key) in product.product_units" :key="key" class="badge badge-primary mr-2 mb-2 font-weight-normal" style="font-size:90%">{{ product_unit.barcode }}</span>
      </p>
    </td>
    <template v-if="prompt_fulfill && product.fulfillment_type==='product_units'">
      <td>
        <order-product-assign-barcodes v-if="product.to_be_fulfilled" :order_id="order._id" :order_product="product"></order-product-assign-barcodes>
        <span v-else class="small text-muted">All units were assigned</span>
      </td>
    </template>
    <template>
      <td class="text-center">
        <div :class="'mb-2 text-' + product.status.class">
          <i :class="product.status.icon"></i>
          {{ product.status.name }}
        </div>
        <order-change-product-status v-if="prompt_fulfill && product.to_be_fulfilled && product.fulfillment_type==='simple'" :order_id="order._id" :order_product_id="product.id"></order-change-product-status>
      </td>
    </template>
    <td class="text-right">{{ product.quantity }}</td>
    <td class="text-right">
      <div v-if="product.quantity > 1" class="mb-2 text-muted small">
        <div v-if="product.regular_price" class="text-line-through">
          {{ product.regular_price | numberToRs }} each
        </div>
        <div>{{ product.price | numberToRs }} each</div>
      </div>
      <div v-if="product.total_regular_price" class="text-muted small text-line-through">
        {{ product.total_regular_price | numberToRs }}
      </div>
      {{ product.total_price | numberToRs }}
    </td>
  </tr>
</template>

<script>
import OrderChangeProductStatus from './ChangeProductStatus'
import OrderProductAssignBarcodes from './ProductAssignBarcodes'

export default {
  name: 'OrderProduct',
  components: {
    OrderProductAssignBarcodes,
    OrderChangeProductStatus
  },
  props: ['order', 'product', 'prompt_fulfill'],
  computed: {
    websiteUrl () {
      return this.$store.state.store ? this.$store.state.store.urls.website : '#'
    }
  }
}
</script>

<style scoped>
  td:first-child {
    padding-left: 20px;
  }
  td:last-child {
    padding-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/partials/Product.vue